<template>
    <div class="innerBox">
      <h2 class="mb-4">Supply Apply</h2>
  
      <vue-universal-table
        api_url="/api/v1/masterdata/supply-apply"
        :indexing="true"
        :fields="vue_universal_table.fields"
      ></vue-universal-table>
  
  
    </div>
  </template>
  
  <script>
    export default {
      data () {
        return {
        
          vue_universal_table : {
            update : 0,
            special_buttons : ['peranBaru'],
            buttons : [
              {
                title : 'Edit',
                class : 'btn-outline-primary fa fa-edit'
              },
              {
                title : 'Delete',
                class : 'btn-outline-danger fa fa-times'
              }
            ],
            fields : [
              {
                title : 'Nama Jasa',
                variable : 'nama_jasa'
              },
              {
                title : 'Tipe Jasa',
                variable : 'tipe_jasa'
              }, {
                title : "Harga",
                variable : 'harga',
                number_formatting : true
              }, {
                title : 'Waktu Tercatat',
                variable : 'waktu_tercatat',
                date_format : 'MMM DD, Y HH:mm'
              }
            ]
          },
          editData : null,
        }
      },
      mounted () {
      },
      methods : {
      }
    }
  </script>
  
  <style scoped>
    
  </style>